import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router';

import Loader from 'honeydew/Loader';
import { useBoysenberrySignupFlag } from 'hooks/useFeatureFlag/useBoysenberrySignupFlag';
import { useDietaryPreferencesFeatureFlag } from 'hooks/useFeatureFlag/useDietaryPreferencesFeatureFlag';
import { useTrackSecretAmplitudeExperiment } from 'hooks/useFeatureFlag/useTrackSecretAmplitudeExperiment';
import useTailwindTheme from 'hooks/useTailwindTheme';

export default function AccountCreationLayout() {
    const {
        isReady: splitIsReady,
        isTimedout: splitIsTimedout,
        key: boysenberrySignupSplitKey,
        treatment: boysenberrySignupTreatment,
    } = useBoysenberrySignupFlag();
    const {
        isOnTreatment: inDietaryPreferencesTreatment,
        key: dietaryPreferencesSplitKey,
        treatment: dietaryPreferencesTreatment,
    } = useDietaryPreferencesFeatureFlag();

    useTrackSecretAmplitudeExperiment();

    const treatment = inDietaryPreferencesTreatment ? dietaryPreferencesTreatment : boysenberrySignupTreatment;
    const splitKey = inDietaryPreferencesTreatment ? dietaryPreferencesSplitKey : boysenberrySignupSplitKey;

    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });
    const onMembershipStep = window.location.pathname === '/join/membership';
    const renderStep = splitIsReady || splitIsTimedout;

    return (
        <>
            <main
                className={clsx('mx-auto flex max-w-screen-md flex-col px-25', {
                    'py-0': onMembershipStep,
                    'py-25': !onMembershipStep,
                })}
            >
                {renderStep ? (
                    <Outlet context={{ splitIsReady, splitKey, treatment, inDietaryPreferencesTreatment }} />
                ) : (
                    <div className="flex justify-center">
                        <Loader width="50" />
                    </div>
                )}
            </main>
            {!mobile && onMembershipStep && (
                <img
                    src="https://img-cdn.misfitsmarket.com/boysenberry/plusmembership/blueberries-desktop.png"
                    alt=""
                    className="fixed bottom-0 z-[-1] w-fit"
                />
            )}
        </>
    );
}
